// import * as React from 'react';
// import {
//   Box,
//   Checkbox,
//   CircularProgress,
//   Divider,
//   FormControl,
//   InputLabel,
//   List,
//   ListItem,
//   MenuItem,
//   Select,
//   Stack,
//   TextField,
//   Typography,
//   Snackbar,
//   Alert,
//   AlertTitle,
//   Slide,
//   SlideProps,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { debounce } from 'lodash';
// import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router';
// import { RootState } from 'store';
// import { genericKeysBody } from '../../../types/genericKeysTypes';
// import {
//   addStaff,
//   fetchMembers,
//   resetForm,
//   setRole,
//   setSearchKey,
//   setSelectedMembers
// } from '../../../slices/NdisSlices/staffManagement/createStaffMembersSlice';
// import { Member, Role, Department } from '../../../types/ndisSection/createStaffMembersTypes';
// import { useClientContext } from '../ProfileMainPage';
// import { clearManagers, fetchManagers } from 'slices/NdisSlices/managersList/ManagersListSlice';
// import { useAppSelector } from 'app/hooks';

// const SlideTransition = (props: SlideProps) => <Slide {...props} direction="up" />;

// type ToastState = {
//   open: boolean;
//   message: string;
//   severity: 'success' | 'error' | 'warning';
// };

// const dropdownOptions: { label: string; value: Department }[] = [
//   { label: 'People & Culture', value: 'people-culture' },
//   { label: 'Corporate Services', value: 'corporate-services' },
//   { label: 'IT', value: 'information-technology' },
//   { label: 'Finance', value: 'finance' },
//   { label: 'Risk & Compliance', value: 'risk-compliance' },
//   { label: 'Marketing', value: 'marketing' }
// ];

// const MemberItem = React.memo(
//   ({
//     member,
//     selected,
//     role,
//     department,
//     loading,
//     roleOptions,
//     departmentOptions,
//     onCheckboxChange,
//     onRoleChange,
//     onDepartmentChange,
//     isMobile
//   }: {
//     member: Member;
//     selected: boolean;
//     role: Role;
//     department: Department;
//     loading: boolean;
//     roleOptions: Role[];
//     departmentOptions: { label: string; value: Department }[];
//     onCheckboxChange: (id: string) => void;
//     onRoleChange: (email: string, role: Role) => void;
//     onDepartmentChange: (email: string, department: Department) => void;
//     isMobile: boolean;
//   }) => {
//     return (
//       <>
//         <ListItem
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'flex-start',
//             py: { xs: 0.5, sm: 1 },
//             px: { xs: 0.5, sm: 1 },
//             width: '100%',
//             boxSizing: 'border-box'
//           }}
//         >
//           <Stack
//             direction="row"
//             alignItems="center"
//             spacing={0.5}
//             width="100%"
//             sx={{ flexWrap: 'wrap' }}
//           >
//             <Checkbox
//               checked={selected}
//               onChange={() => onCheckboxChange(member.id)}
//               color="primary"
//               disabled={loading}
//               size="small"
//               sx={{
//                 padding: { xs: '2px', sm: '4px' },
//                 '& .MuiSvgIcon-root': {
//                   fontSize: { xs: '0.875rem', sm: '1rem' }
//                 }
//               }}
//             />
//             <Typography
//               variant={isMobile ? 'caption' : 'body2'}
//               sx={{
//                 flexGrow: 1,
//                 wordBreak: 'break-word',
//                 fontSize: { xs: '0.65rem', sm: '0.75rem' }
//               }}
//             >
//               {member.email}
//             </Typography>
//           </Stack>

//           <Stack
//             direction={isMobile ? 'column' : 'row'}
//             spacing={isMobile ? 0.5 : 1}
//             sx={{
//               width: '100%',
//               mt: { xs: 0.5, sm: 1 },
//               ml: isMobile ? 0 : '30px',
//               pl: isMobile ? '30px' : 0,
//               flexWrap: isMobile ? 'wrap' : 'nowrap'
//             }}
//           >
//             <FormControl
//               variant="outlined"
//               sx={{
//                 flex: 1,
//                 minWidth: { xs: '100%', sm: '140px' },
//                 maxWidth: '100%'
//               }}
//               disabled={loading || !selected}
//               size="small"
//             >
//               <InputLabel sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}>Role</InputLabel>
//               <Select
//                 value={role}
//                 onChange={(e) => onRoleChange(member.email, e.target.value as Role)}
//                 label="Role"
//                 sx={{
//                   height: { xs: '32px', sm: '36px' },
//                   fontSize: { xs: '0.65rem', sm: '0.75rem' },
//                   '& .MuiSelect-select': {
//                     py: { xs: 0.5, sm: 0.75 }
//                   }
//                 }}
//               >
//                 {roleOptions.map((roleOption) => (
//                   <MenuItem
//                     key={roleOption}
//                     value={roleOption}
//                     sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
//                   >
//                     {roleOption}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl
//               variant="outlined"
//               sx={{
//                 flex: 1,
//                 minWidth: { xs: '100%', sm: '140px' },
//                 maxWidth: '100%'
//               }}
//               disabled={loading || !selected}
//               size="small"
//             >
//               <InputLabel sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}>
//                 Department
//               </InputLabel>
//               <Select
//                 value={department || dropdownOptions[0].value}
//                 onChange={(e) => onDepartmentChange(member.email, e.target.value as Department)}
//                 label="Department"
//                 sx={{
//                   height: { xs: '32px', sm: '36px' },
//                   fontSize: { xs: '0.65rem', sm: '0.75rem' },
//                   '& .MuiSelect-select': {
//                     py: { xs: 0.5, sm: 0.75 }
//                   }
//                 }}
//               >
//                 {departmentOptions.map((option) => (
//                   <MenuItem
//                     key={option.value}
//                     value={option.value}
//                     sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
//                   >
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Stack>
//         </ListItem>
//         <Divider sx={{ my: 0 }} />
//       </>
//     );
//   }
// );

// interface CreateStaffMembersProps {
//   onClose?: () => void;
//   renderButton?: (props: {
//     handleSubmit: () => void;
//     loading: boolean;
//     selectedMembersCount: number;
//   }) => React.ReactNode;
// }

// const CreateStaffMembers: React.FC<CreateStaffMembersProps> = ({ onClose, renderButton }) => {
//   const dispatch = useDispatch();
//   const { searchKey, members, selectedMembers, roles, departments, loading, error } = useSelector(
//     (state: RootState) => state.createStaffMembers
//   );
//   const [localSearch, setLocalSearch] = useState(searchKey);
//   const [toast, setToast] = useState<ToastState>({
//     open: false,
//     message: '',
//     severity: 'success'
//   });
//   const prevLoadingRef = useRef(loading);
//   const submittedMembersRef = useRef<{ id: string; role: Role; department: Department }[]>([]);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
//   const selectedServiceTitle = useAppSelector(
//     (state) => state.serviceSelected.selectedServiceTitle
//   );
//   const userDetails = localStorage.getItem('user-details');
//   const loggedInWorkerName = userDetails ? JSON.parse(userDetails)?.name || '' : '';
//   const location = useLocation();
//   const componentParentId = location.pathname;
//   const { selectedClient } = useClientContext();

//   const reqBody: genericKeysBody = useMemo(
//     () => ({
//       group_id: selectedProjectId || '',
//       service_name_id: selectedServiceTitle || '',
//       component_parent_id: componentParentId,
//       nested_component_id: 'Add staff members',
//       user_whoRequested_id: loggedInWorkerName
//     }),
//     [selectedProjectId, selectedServiceTitle, componentParentId, loggedInWorkerName]
//   );

//   const roleOptions: Role[] = useMemo(
//     () => ['Support worker', 'Manager', 'Office support', 'Coordinator'],
//     []
//   );

//   const departmentOptions = useMemo(() => dropdownOptions, []);

//   const debouncedSearch = useMemo(
//     () =>
//       debounce((value: string) => {
//         const payload = {
//           group_id: selectedProjectId || '',
//           service_name_id: selectedServiceTitle || '',
//           search_key: value || ''
//         };
//         dispatch(setSearchKey(value));
//         dispatch(fetchMembers(payload));
//       }, 500),
//     [dispatch, selectedProjectId, selectedServiceTitle]
//   );

//   useEffect(() => {
//     return () => {
//       debouncedSearch.cancel();
//       dispatch(resetForm());
//       dispatch(clearManagers());
//     };
//   }, [debouncedSearch, dispatch]);

//   const handleSearchChange = useCallback(
//     (e: React.ChangeEvent<HTMLInputElement>) => {
//       setLocalSearch(e.target.value);
//       debouncedSearch(e.target.value);
//     },
//     [debouncedSearch]
//   );

//   const handleCheckboxChange = useCallback(
//     (id: string) => {
//       dispatch(
//         setSelectedMembers(
//           selectedMembers.includes(id)
//             ? selectedMembers.filter((e) => e !== id)
//             : [...selectedMembers, id]
//         )
//       );
//     },
//     [dispatch, selectedMembers]
//   );

//   const handleRoleChange = useCallback(
//     (email: string, role: Role) => {
//       dispatch(setRole({ email, role, department: departments[email] }));
//     },
//     [dispatch, departments]
//   );

//   const handleDepartmentChange = useCallback(
//     (email: string, department: Department) => {
//       dispatch(setRole({ email, role: roles[email] || roleOptions[0], department }));
//     },
//     [dispatch, roles, roleOptions]
//   );

//   const handleCloseToast = useCallback((event?: React.SyntheticEvent | Event, reason?: string) => {
//     if (reason === 'clickaway') {
//       return;
//     }
//     setToast((prev) => ({ ...prev, open: false }));
//   }, []);

//   const handleSubmit = useCallback(async () => {
//     if (selectedMembers.length === 0) {
//       setToast({
//         open: true,
//         message: 'Please select at least one member to add.',
//         severity: 'warning'
//       });
//       return;
//     }

//     if (!selectedClient?.label) {
//       setToast({
//         open: true,
//         message: 'No client selected. Please select a client first.',
//         severity: 'error'
//       });
//       return;
//     }

//     submittedMembersRef.current = selectedMembers.map((id) => {
//       const member = members.find((m) => m.id === id);
//       return {
//         id,
//         role: roles[member?.email || ''] || roleOptions[0],
//         department: departments[member?.email || ''] || departmentOptions[0].value
//       };
//     });

//     const payload = selectedMembers.map((id) => {
//       const member = members.find((m) => m.id === id);
//       return {
//         id,
//         email: member?.email || '',
//         username: member?.username || '',
//         ndis_role: roles[member?.email || ''] || roleOptions[0],
//         department: departments[member?.email || ''] || departmentOptions[0].value,
//         client_name: selectedClient.label,
//         ...reqBody
//       };
//     });

//     dispatch(addStaff(payload));
//   }, [
//     dispatch,
//     selectedMembers,
//     members,
//     roles,
//     departments,
//     roleOptions,
//     departmentOptions,
//     reqBody,
//     selectedClient
//   ]);

//   const getNestedComponentId = useCallback(() => {
//     switch (location.pathname) {
//       case '/profile/managers':
//         return 'Managers';
//       case '/profile/office-support':
//         return 'Office Support';
//       case '/profile/support-workers':
//         return 'Support Workers';
//       default:
//         return 'Managers';
//     }
//   }, [location.pathname]);

//   useEffect(() => {
//     if (error) {
//       setToast({
//         open: true,
//         message: error,
//         severity: 'error'
//       });
//       submittedMembersRef.current = [];
//     } else if (prevLoadingRef.current && !loading && submittedMembersRef.current.length > 0) {
//       setToast({
//         open: true,
//         message: 'Staff members added successfully!',
//         severity: 'success'
//       });
//       if (searchKey.trim()) {
//         const payload = {
//           group_id: selectedProjectId || '',
//           service_name_id: selectedServiceTitle || '',
//           search_key: searchKey || ''
//         };
//         dispatch(fetchMembers(payload));
//       }

//       if (selectedClient?.label && selectedProjectId && selectedServiceTitle) {
//         submittedMembersRef.current.forEach(({ id, role, department }) => {
//           const member = members.find((m) => m.id === id);
//           const payload = {
//             group_id: selectedProjectId,
//             service_name_id: selectedServiceTitle,
//             nested_component_id: getNestedComponentId(),
//             email: member?.email || '',
//             roles: [role],
//             department,
//             client_name: selectedClient.label
//           };
//           dispatch(fetchManagers(payload));
//         });
//       }

//       submittedMembersRef.current = [];
//       if (onClose) {
//         setTimeout(onClose, 1000);
//       }
//     }
//     prevLoadingRef.current = loading;
//   }, [
//     error,
//     loading,
//     searchKey,
//     selectedClient?.label,
//     selectedProjectId,
//     selectedServiceTitle,
//     dispatch,
//     getNestedComponentId,
//     onClose,
//     members
//   ]);

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         maxWidth: '100%',
//         mx: 'auto',
//         p: { xs: 0.5, sm: 1 },
//         bgcolor: 'background.paper',
//         boxSizing: 'border-box',
//         display: 'flex',
//         flexDirection: 'column',
//         minHeight: '100%',
//         overflowX: 'hidden'
//       }}
//     >
//       <Stack spacing={1} sx={{ width: '100%', flexGrow: 1 }}>
//         <Typography
//           variant="h6"
//           sx={{
//             fontWeight: 600,
//             px: 0.5,
//             color: 'text.primary',
//             fontSize: { xs: '0.875rem', sm: '1rem' }
//           }}
//         >
//           Add Staff/Participants
//         </Typography>

//         <TextField
//           fullWidth
//           placeholder="Search by email"
//           value={localSearch}
//           onChange={handleSearchChange}
//           variant="outlined"
//           disabled={loading}
//           size="small"
//           sx={{
//             '& .MuiInputBase-input': {
//               fontSize: { xs: '0.65rem', sm: '0.75rem' },
//               py: { xs: 0.5, sm: 0.75 }
//             },
//             '& .MuiOutlinedInput-root': {
//               height: { xs: '32px', sm: '36px' }
//             }
//           }}
//           InputProps={{
//             endAdornment: loading ? <CircularProgress size={16} /> : null
//           }}
//         />

//         {loading && !members.length && (
//           <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
//             <CircularProgress size={16} />
//             <Typography
//               variant={isMobile ? 'caption' : 'body2'}
//               sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
//             >
//               Loading...
//             </Typography>
//           </Stack>
//         )}

//         <Box
//           sx={{
//             flexGrow: 1,
//             overflowY: 'auto',
//             overflowX: 'hidden',
//             '&::-webkit-scrollbar': {
//               width: '6px'
//             },
//             '&::-webkit-scrollbar-thumb': {
//               backgroundColor: theme.palette.primary.main,
//               borderRadius: '3px'
//             },
//             '&::-webkit-scrollbar-track': {
//               backgroundColor: theme.palette.grey[200]
//             }
//           }}
//         >
//           {Array.isArray(members) && members.length > 0 ? (
//             <List sx={{ p: 0 }}>
//               {members.map((member) => (
//                 <MemberItem
//                   key={member.id}
//                   member={member}
//                   selected={selectedMembers.includes(member.id)}
//                   role={roles[member.email] || roleOptions[0]}
//                   department={departments[member.email] || departmentOptions[0].value}
//                   loading={loading}
//                   roleOptions={roleOptions}
//                   departmentOptions={departmentOptions}
//                   onCheckboxChange={handleCheckboxChange}
//                   onRoleChange={handleRoleChange}
//                   onDepartmentChange={handleDepartmentChange}
//                   isMobile={isMobile}
//                 />
//               ))}
//             </List>
//           ) : (
//             <Box sx={{ p: { xs: 1, sm: 2 }, textAlign: 'center' }}>
//               <Typography
//                 variant={isMobile ? 'caption' : 'body2'}
//                 color="text.secondary"
//                 sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
//               >
//                 {localSearch ? 'No members found' : 'Search for members by email'}
//               </Typography>
//             </Box>
//           )}
//         </Box>
//       </Stack>

//       {renderButton &&
//         renderButton({ handleSubmit, loading, selectedMembersCount: selectedMembers.length })}

//       <Snackbar
//         open={toast.open}
//         autoHideDuration={5000}
//         onClose={handleCloseToast}
//         TransitionComponent={SlideTransition}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//         sx={{
//           bottom: { xs: 16, sm: 24 },
//           width: { xs: '90%', sm: 'auto' }
//         }}
//       >
//         <Alert
//           onClose={handleCloseToast}
//           severity={toast.severity}
//           variant="filled"
//           sx={{
//             width: '100%',
//             '& .MuiAlert-message': {
//               fontSize: { xs: '0.65rem', sm: '0.75rem' }
//             },
//             '& .MuiAlertTitle-root': {
//               fontSize: { xs: '0.75rem', sm: '0.875rem' },
//               mb: 0.5
//             }
//           }}
//         >
//           <AlertTitle sx={{ fontWeight: 600 }}>
//             {toast.severity === 'success'
//               ? 'Success'
//               : toast.severity === 'error'
//               ? 'Error'
//               : 'Notice'}
//           </AlertTitle>
//           {toast.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default CreateStaffMembers;

import * as React from 'react';
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Snackbar,
  Alert,
  AlertTitle,
  Slide,
  SlideProps,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { debounce } from 'lodash';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { RootState } from 'store';
import { genericKeysBody } from '../../../types/genericKeysTypes';
import {
  listScreenings,
  ListScreeningsPayload,
  resetScreeningsState,
  Screening
} from '../../../slices/payrolslices/PeopleSlice';
import { Role, Department } from '../../../types/ndisSection/createStaffMembersTypes';
import { useClientContext } from '../ProfileMainPage';
import { clearManagers, fetchManagers } from 'slices/NdisSlices/managersList/ManagersListSlice';
import { useAppSelector } from 'app/hooks';
import axiosInstance from 'Services/APIService';
import { addStaff } from 'slices/NdisSlices/staffManagement/createStaffMembersSlice';

const SlideTransition = (props: SlideProps) => <Slide {...props} direction="up" />;

type ToastState = {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning';
};

const dropdownOptions: { label: string; value: Department }[] = [
  { label: 'People & Culture', value: 'people-culture' },
  { label: 'Corporate Services', value: 'corporate-services' },
  { label: 'IT', value: 'information-technology' },
  { label: 'Finance', value: 'finance' },
  { label: 'Risk & Compliance', value: 'risk-compliance' },
  { label: 'Marketing', value: 'marketing' }
];

// FIXED: Safe client name extraction function
function getClientLabel(client: any): string | undefined {
  if (!client) return undefined;
  if (typeof client === 'string') return client;
  if ('label' in client && typeof client.label === 'string') return client.label;
  return undefined;
}

const MemberItem = React.memo(
  ({
    screening,
    selected,
    role,
    department,
    loading,
    roleOptions,
    departmentOptions,
    onCheckboxChange,
    onRoleChange,
    onDepartmentChange,
    isMobile,
    avatarUrl
  }: {
    screening: Screening;
    selected: boolean;
    role: Role;
    department: Department;
    loading: boolean;
    roleOptions: Role[];
    departmentOptions: { label: string; value: Department }[];
    onCheckboxChange: (id: string) => void;
    onRoleChange: (email: string, role: Role) => void;
    onDepartmentChange: (email: string, department: Department) => void;
    isMobile: boolean;
    avatarUrl: string | null;
  }) => {
    return (
      <>
        <ListItem
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            py: { xs: 0.5, sm: 1 },
            px: { xs: 0.5, sm: 1 },
            width: '100%',
            boxSizing: 'border-box'
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.5}
            width="100%"
            sx={{ flexWrap: 'wrap' }}
          >
            <Checkbox
              checked={selected}
              onChange={() => onCheckboxChange(screening.employeeId)}
              color="primary"
              disabled={loading}
              size="small"
              sx={{
                padding: { xs: '2px', sm: '4px' },
                '& .MuiSvgIcon-root': {
                  fontSize: { xs: '0.875rem', sm: '1rem' }
                }
              }}
            />

            <Avatar
              src={avatarUrl || undefined}
              alt={screening.employeeName}
              sx={{
                width: { xs: 24, sm: 28 },
                height: { xs: 24, sm: 28 },
                fontSize: { xs: '0.625rem', sm: '0.75rem' },
                mr: 0.5
              }}
            >
              {screening.employeeName.charAt(0).toUpperCase()}
            </Avatar>

            <Box
              sx={{
                flexGrow: 1,
                minWidth: 0
              }}
            >
              <Typography
                variant={isMobile ? 'caption' : 'body2'}
                sx={{
                  fontSize: { xs: '0.65rem', sm: '0.75rem' },
                  fontWeight: 500,
                  lineHeight: 1.2,
                  display: 'block'
                }}
              >
                {screening.employeeName}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  fontSize: { xs: '0.6rem', sm: '0.65rem' },
                  lineHeight: 1.2,
                  display: 'block'
                }}
              >
                {screening.email}
              </Typography>
            </Box>
          </Stack>

          <Stack
            direction={isMobile ? 'column' : 'row'}
            spacing={isMobile ? 0.5 : 1}
            sx={{
              width: '100%',
              mt: { xs: 0.5, sm: 1 },
              ml: isMobile ? 0 : '30px',
              pl: isMobile ? '30px' : 0,
              flexWrap: isMobile ? 'wrap' : 'nowrap'
            }}
          >
            <FormControl
              variant="outlined"
              sx={{
                flex: 1,
                minWidth: { xs: '100%', sm: '140px' },
                maxWidth: '100%'
              }}
              disabled={loading || !selected}
              size="small"
            >
              <InputLabel sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}>Role</InputLabel>
              <Select
                value={role}
                onChange={(e) => onRoleChange(screening.email, e.target.value as Role)}
                label="Role"
                sx={{
                  height: { xs: '32px', sm: '36px' },
                  fontSize: { xs: '0.65rem', sm: '0.75rem' },
                  '& .MuiSelect-select': {
                    py: { xs: 0.5, sm: 0.75 }
                  }
                }}
              >
                {roleOptions.map((roleOption) => (
                  <MenuItem
                    key={roleOption}
                    value={roleOption}
                    sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
                  >
                    {roleOption}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl
              variant="outlined"
              sx={{
                flex: 1,
                minWidth: { xs: '100%', sm: '140px' },
                maxWidth: '100%'
              }}
              disabled={loading || !selected}
              size="small"
            >
              <InputLabel sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}>
                Department
              </InputLabel>
              <Select
                value={department || dropdownOptions[0].value}
                onChange={(e) => onDepartmentChange(screening.email, e.target.value as Department)}
                label="Department"
                sx={{
                  height: { xs: '32px', sm: '36px' },
                  fontSize: { xs: '0.65rem', sm: '0.75rem' },
                  '& .MuiSelect-select': {
                    py: { xs: 0.5, sm: 0.75 }
                  }
                }}
              >
                {departmentOptions.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </ListItem>
        <Divider sx={{ my: 0 }} />
      </>
    );
  }
);

interface CreateStaffMembersProps {
  onClose?: () => void;
  renderButton?: (props: {
    handleSubmit: () => void;
    loading: boolean;
    selectedMembersCount: number;
  }) => React.ReactNode;
}

const CreateStaffMembers: React.FC<CreateStaffMembersProps> = ({ onClose, renderButton }) => {
  const dispatch = useDispatch();

  // Use people slice state
  const { screenings, nextToken, loadingScreenings, screeningsError, hasMoreScreenings } =
    useSelector((state: RootState) => state.people);

  // ADDED: Track save loading state from createStaffMembers slice
  const { loading: saveLoading, error: saveError } = useSelector(
    (state: RootState) => state.createStaffMembers
  );

  const [searchKey, setSearchKeyLocal] = useState('');
  const [selectedMembers, setSelectedMembersLocal] = useState<string[]>([]);
  const [roles, setRoles] = useState<Record<string, Role>>({});
  const [departments, setDepartments] = useState<Record<string, Department>>({});
  const [localSearch, setLocalSearch] = useState('');
  const [avatarUrls, setAvatarUrls] = useState<{ [key: string]: string | null }>({});
  const [toast, setToast] = useState<ToastState>({
    open: false,
    message: '',
    severity: 'success'
  });
  const prevSaveLoadingRef = useRef(saveLoading);
  const submittedMembersRef = useRef<{ id: string; role: Role; department: Department }[]>([]);
  const [initialFetchDone, setInitialFetchDone] = useState(false);

  const avatarFetchingRef = useRef(false);
  const previousScreeningsLengthRef = useRef(0);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
  const selectedServiceTitle = useAppSelector(
    (state) => state.serviceSelected.selectedServiceTitle
  );
  const userDetails = localStorage.getItem('user-details');
  const loggedInWorkerName = userDetails ? JSON.parse(userDetails)?.name || '' : '';
  const location = useLocation();
  const componentParentId = location.pathname;
  const { selectedClient } = useClientContext();

  const reqBody: genericKeysBody = useMemo(
    () => ({
      group_id: selectedProjectId || '',
      service_name_id: selectedServiceTitle || '',
      component_parent_id: componentParentId,
      nested_component_id: 'Add staff members',
      user_whoRequested_id: loggedInWorkerName
    }),
    [selectedProjectId, selectedServiceTitle, componentParentId, loggedInWorkerName]
  );

  const roleOptions: Role[] = useMemo(
    () => ['Support worker', 'Manager', 'Office support', 'Coordinator'],
    []
  );

  const departmentOptions = useMemo(() => dropdownOptions, []);

  // Build payload - removed competency filter
  const buildPayload = useCallback(
    (searchTerm?: string): ListScreeningsPayload => {
      const payload: ListScreeningsPayload = {
        group_id: selectedProjectId || '',
        service_id: 'People Screening',
        page_size: 20,
        competency: 'competent'
      };

      const searchValue = searchTerm !== undefined ? searchTerm : searchKey;
      if (searchValue && searchValue.trim()) {
        payload.search = searchValue.trim();
      }

      return payload;
    },
    [selectedProjectId, selectedServiceTitle, searchKey]
  );

  // Debounced search function
  const debouncedSearch = useMemo(
    () =>
      debounce((value: string) => {
        setSearchKeyLocal(value);
        if (selectedProjectId && selectedServiceTitle) {
          dispatch(resetScreeningsState());
          const payload: ListScreeningsPayload = {
            group_id: selectedProjectId,
            service_id: 'People Screening',
            page_size: 20,
            competency: 'competent'
          };

          if (value && value.trim()) {
            payload.search = value.trim();
          }

          dispatch(listScreenings(payload));
        }
      }, 500),
    [dispatch, selectedProjectId, selectedServiceTitle]
  );

  // FIXED: Define getNestedComponentId BEFORE using it in useEffect
  const getNestedComponentId = useCallback(() => {
    switch (location.pathname) {
      case '/profile/managers':
        return 'Managers';
      case '/profile/office-support':
        return 'Office Support';
      case '/profile/support-workers':
        return 'Support Workers';
      default:
        return 'Managers';
    }
  }, [location.pathname]);

  // Avatar fetching effect
  useEffect(() => {
    const fetchAvatars = async () => {
      if (avatarFetchingRef.current) return;
      if (!screenings?.length || screenings.length === previousScreeningsLengthRef.current) return;

      avatarFetchingRef.current = true;
      previousScreeningsLengthRef.current = screenings.length;

      const newAvatarUrls: { [key: string]: string | null } = { ...avatarUrls };

      for (const screening of screenings) {
        if (newAvatarUrls[screening.employeeId] !== undefined) continue;

        if (screening.avatar) {
          try {
            const response = await axiosInstance.get(
              `/avatar/get-avatar?path=${encodeURIComponent(screening.avatar)}`,
              { responseType: 'blob' }
            );
            const imageUrl = URL.createObjectURL(response.data);
            newAvatarUrls[screening.employeeId] = imageUrl;
          } catch (error) {
            console.error(`Error fetching avatar for ${screening.employeeName}:`, error);
            newAvatarUrls[screening.employeeId] = null;
          }
        } else {
          newAvatarUrls[screening.employeeId] = null;
        }
      }

      setAvatarUrls(newAvatarUrls);
      avatarFetchingRef.current = false;
    };

    fetchAvatars();
  }, [screenings]);

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
      dispatch(resetScreeningsState());
      dispatch(clearManagers());

      Object.values(avatarUrls).forEach((url) => {
        if (url) URL.revokeObjectURL(url);
      });

      avatarFetchingRef.current = false;
      previousScreeningsLengthRef.current = 0;
    };
  }, [debouncedSearch, dispatch]);

  // Initial fetch when component mounts
  useEffect(() => {
    if (selectedProjectId && selectedServiceTitle && !initialFetchDone) {
      dispatch(resetScreeningsState());
      const initialPayload = buildPayload('');
      dispatch(listScreenings(initialPayload));
      setInitialFetchDone(true);
    }
  }, [dispatch, selectedProjectId, selectedServiceTitle, buildPayload, initialFetchDone]);

  // ADDED: Watch for save completion and refresh list
  useEffect(() => {
    if (prevSaveLoadingRef.current && !saveLoading && submittedMembersRef.current.length > 0) {
      if (!saveError) {
        setToast({
          open: true,
          message: 'Staff members added successfully!',
          severity: 'success'
        });

        // Clear selections after successful save
        setSelectedMembersLocal([]);
        setRoles({});
        setDepartments({});

        // Refresh the list to continue adding more
        if (selectedProjectId && selectedServiceTitle) {
          dispatch(resetScreeningsState());
          const refreshPayload = buildPayload(searchKey);
          dispatch(listScreenings(refreshPayload));
        }

        // Fetch managers if needed
        if (getClientLabel(selectedClient) && selectedProjectId && selectedServiceTitle) {
          submittedMembersRef.current.forEach(({ id, role, department }) => {
            const screening = screenings.find((s) => s.employeeId === id);
            const payload = {
              group_id: selectedProjectId,
              service_name_id: selectedServiceTitle,
              nested_component_id: getNestedComponentId(),
              email: screening?.email || '',
              roles: [role],
              department,
              client_name: getClientLabel(selectedClient) || selectedProjectId
            };
            dispatch(fetchManagers(payload));
          });
        }

        submittedMembersRef.current = [];

        // Optional: Close dialog after delay
        if (onClose) {
          setTimeout(onClose, 1500);
        }
      } else {
        setToast({
          open: true,
          message: saveError || 'Failed to add staff members.',
          severity: 'error'
        });
        submittedMembersRef.current = [];
      }
    }
    prevSaveLoadingRef.current = saveLoading;
  }, [
    saveLoading,
    saveError,
    searchKey,
    selectedClient,
    selectedProjectId,
    selectedServiceTitle,
    dispatch,
    getNestedComponentId,
    onClose,
    screenings,
    buildPayload
  ]);

  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setLocalSearch(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  const handleCheckboxChange = useCallback((id: string) => {
    setSelectedMembersLocal((prev) =>
      prev.includes(id) ? prev.filter((e) => e !== id) : [...prev, id]
    );
  }, []);

  const handleRoleChange = useCallback((email: string, role: Role) => {
    setRoles((prev) => ({ ...prev, [email]: role }));
  }, []);

  const handleDepartmentChange = useCallback((email: string, department: Department) => {
    setDepartments((prev) => ({ ...prev, [email]: department }));
  }, []);

  const handleCloseToast = useCallback((event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setToast((prev) => ({ ...prev, open: false }));
  }, []);

  // Load more functionality
  const handleLoadMore = useCallback(() => {
    if (!hasMoreScreenings || loadingScreenings || !nextToken) return;

    const payload: ListScreeningsPayload = {
      ...buildPayload(),
      next_token: nextToken
    };

    dispatch(listScreenings(payload));
  }, [dispatch, buildPayload, nextToken, hasMoreScreenings, loadingScreenings]);

  // FIXED: Submit handler with save loading state
  const handleSubmit = useCallback(async () => {
    if (saveLoading) return; // Prevent double submission

    if (selectedMembers.length === 0) {
      setToast({
        open: true,
        message: 'Please select at least one member to add.',
        severity: 'warning'
      });
      return;
    }

    const clientName = getClientLabel(selectedClient) || selectedProjectId;

    if (!clientName) {
      setToast({
        open: true,
        message: 'No client selected. Please select a client first.',
        severity: 'error'
      });
      return;
    }

    submittedMembersRef.current = selectedMembers.map((id) => {
      const screening = screenings.find((s) => s.employeeId === id);
      return {
        id,
        role: roles[screening?.email || ''] || roleOptions[0],
        department: departments[screening?.email || ''] || departmentOptions[0].value
      };
    });

    const payload = selectedMembers.map((id) => {
      const screening = screenings.find((s) => s.employeeId === id);
      return {
        id,
        email: screening?.email || '',
        username: screening?.employeeName || '',
        ndis_role: roles[screening?.email || ''] || roleOptions[0],
        department: departments[screening?.email || ''] || departmentOptions[0].value,
        client_name: clientName,
        ...reqBody
      };
    });

    dispatch(addStaff(payload));
  }, [
    saveLoading,
    selectedMembers,
    screenings,
    roles,
    departments,
    roleOptions,
    departmentOptions,
    reqBody,
    selectedClient,
    selectedProjectId,
    dispatch
  ]);

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        mx: 'auto',
        p: { xs: 0.5, sm: 1 },
        bgcolor: 'background.paper',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        overflowX: 'hidden'
      }}
    >
      <Stack spacing={1} sx={{ width: '100%', flexGrow: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            px: 0.5,
            color: 'text.primary',
            fontSize: { xs: '0.875rem', sm: '1rem' }
          }}
        >
          Add Staff/Participants
        </Typography>

        <TextField
          fullWidth
          placeholder="Search by name or email"
          value={localSearch}
          onChange={handleSearchChange}
          variant="outlined"
          disabled={loadingScreenings || saveLoading}
          size="small"
          sx={{
            '& .MuiInputBase-input': {
              fontSize: { xs: '0.65rem', sm: '0.75rem' },
              py: { xs: 0.5, sm: 0.75 }
            },
            '& .MuiOutlinedInput-root': {
              height: { xs: '32px', sm: '36px' }
            }
          }}
          InputProps={{
            endAdornment: loadingScreenings || saveLoading ? <CircularProgress size={16} /> : null
          }}
        />

        {loadingScreenings && !screenings.length && (
          <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
            <CircularProgress size={16} />
            <Typography
              variant={isMobile ? 'caption' : 'body2'}
              sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
            >
              Loading...
            </Typography>
          </Stack>
        )}

        <Box
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            '&::-webkit-scrollbar': {
              width: '6px'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: theme.palette.primary.main,
              borderRadius: '3px'
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: theme.palette.grey[200]
            }
          }}
        >
          {Array.isArray(screenings) && screenings.length > 0 ? (
            <>
              <List sx={{ p: 0 }}>
                {screenings.map((screening) => (
                  <MemberItem
                    key={screening.employeeId}
                    screening={screening}
                    selected={selectedMembers.includes(screening.employeeId)}
                    role={roles[screening.email] || roleOptions[0]}
                    department={departments[screening.email] || departmentOptions[0].value}
                    loading={loadingScreenings || saveLoading}
                    roleOptions={roleOptions}
                    departmentOptions={departmentOptions}
                    onCheckboxChange={handleCheckboxChange}
                    onRoleChange={handleRoleChange}
                    onDepartmentChange={handleDepartmentChange}
                    isMobile={isMobile}
                    avatarUrl={avatarUrls[screening.employeeId] || null}
                  />
                ))}
              </List>

              {hasMoreScreenings && (
                <Box sx={{ p: { xs: 1, sm: 2 }, textAlign: 'center' }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleLoadMore}
                    disabled={loadingScreenings || saveLoading}
                    sx={{
                      fontSize: { xs: '0.65rem', sm: '0.75rem' },
                      py: { xs: 0.5, sm: 0.75 },
                      px: { xs: 1.5, sm: 2 }
                    }}
                  >
                    {loadingScreenings ? <CircularProgress size={16} /> : 'Load More'}
                  </Button>
                </Box>
              )}

              {loadingScreenings && screenings.length > 0 && (
                <Box sx={{ textAlign: 'center', py: 2 }}>
                  <CircularProgress size={20} />
                </Box>
              )}
            </>
          ) : (
            <Box sx={{ p: { xs: 1, sm: 2 }, textAlign: 'center' }}>
              <Typography
                variant={isMobile ? 'caption' : 'body2'}
                color="text.secondary"
                sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
              >
                {localSearch ? 'No members found' : 'Search for members by name or email'}
              </Typography>
            </Box>
          )}
        </Box>

        {screenings?.length > 0 && (
          <Box sx={{ px: 0.5 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
              >
                Showing {screenings.length} people
              </Typography>
              {selectedMembers.length > 0 && (
                <Typography
                  variant="caption"
                  color="primary.main"
                  sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
                >
                  {selectedMembers.length} selected
                </Typography>
              )}
            </Stack>
          </Box>
        )}
      </Stack>

      {renderButton &&
        renderButton({
          handleSubmit,
          loading: saveLoading,
          selectedMembersCount: selectedMembers.length
        })}

      <Snackbar
        open={toast.open}
        autoHideDuration={5000}
        onClose={handleCloseToast}
        TransitionComponent={SlideTransition}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{
          bottom: { xs: 16, sm: 24 },
          width: { xs: '90%', sm: 'auto' }
        }}
      >
        <Alert
          onClose={handleCloseToast}
          severity={toast.severity}
          variant="filled"
          sx={{
            width: '100%',
            '& .MuiAlert-message': {
              fontSize: { xs: '0.65rem', sm: '0.75rem' }
            },
            '& .MuiAlertTitle-root': {
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              mb: 0.5
            }
          }}
        >
          <AlertTitle sx={{ fontWeight: 600 }}>
            {toast.severity === 'success'
              ? 'Success'
              : toast.severity === 'error'
              ? 'Error'
              : 'Notice'}
          </AlertTitle>
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateStaffMembers;
